/* @flow */

import * as React from 'react';
import FunkyIcon from 'app/components/commons/FunkyIcon';
import {
  COMPLETED,
  IN_MANUAL_REVIEW,
  IN_PROGRESS,
  IN_REVIEW,
  OPEN,
  SCHEDULED
} from 'app/constants/challengeStatusTypes';

type Props = {
  iconType?: string,
  statusId: number
};

const defaultProps = {
  iconType: undefined
};

function StatusIcon({ iconType, statusId }: Props) {
  const type = {
    [SCHEDULED]: 'scheduled',
    [OPEN]: 'scheduled',
    [IN_PROGRESS]: 'live',
    [IN_MANUAL_REVIEW]: 'live',
    [IN_REVIEW]: 'pending',
    [COMPLETED]: 'tick'
  }[statusId];

  return <FunkyIcon type={type} iconType={iconType} />;
}

StatusIcon.defaultProps = defaultProps;

export default StatusIcon;
